import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {Button} from "reactstrap";
import CardHeader from "@material-ui/core/CardHeader";
import Select from "react-select";
import API from "@beardeddevops/react.api";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";

class Copyable extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Copyables._name);
		this.state.sub_regions = [];
		this.state.selectedSubRegion = null;
		this.state.isGeneric = true;
		this.state.userRoles = this.props.userRoles;
		this.state.selectedUserRoles = [];
	}

	componentDidMount() {
		super.componentDidMount();
	}

	componentDidUpdate(prevState, prevProps, snapshot) {
		if (this.state.user_accesses.length > 1 && this.state.selectedUserRoles.length === 0 && this.state.userRoles) {
			this.setState({selectedUserRoles: this.state.user_accesses.split(',').map((access) => {
					const foundRole = this.state.userRoles.find((role) => role.value == access);
					return {value: foundRole.value, label: foundRole.name}
				})})
		}
	}

	handleRegionSelect = async (property, value, linked, object) => {
		await this.getSubRegions(value)

		this.handleSelectPropertyUpdate(property, value, linked, object);
	}

	getSubRegions = async (region) => {
		let model = new API.BuildClass(Types.Regions_Subs._name, API.RequestType.READ);
		this.read = 'GET_BY_REGION';
		model.parent = region;
		this.data = await model.submit(null, this.read);
		this.setState({
			sub_regions: this.data.items
		});
	}

	handleCopy = () => {
		navigator.clipboard.writeText(this.state.information);
	}

	handleRoles = async (value) => {
		if (value) {
			let roles = [];
			for (let i = 0; i < value.length; i++) {
				roles.splice(0, 0, value[i]);
			}
			this.state.selectedUserRoles = roles;
		} else {
			this.state.selectedUserRoles = [];
		}
		this.setState({
			user_accesses: this.state.selectedUserRoles.map((role => {
				return role.value
			})).join(',')
		})
	}

	handleSubmit = (event) => {
		if (this.state.user_accesses.length < 1) {
			this.state.user_accesses = '15,20,25,26,30,40,50'
		}
		super.handleSubmit(event, false, false)
	}


	render() {
		const {properties} = this.model;
		let object = this.state;
		let {
			loaded,
			region,
			region_error,
			regions,
		} = this.state;

		return (
			<fieldset>
				{this.props.isNew && <div className={'row pb-2'}>
					<div className={'col-2'}>
						<FormGroup>
							<FormControlLabel control={
								<Checkbox
									checked={this.state.isGeneric}
									onChange={() => {
										this.setState({isGeneric: !this.state.isGeneric})
									}}
									color={'primary'}
								/>
							} label={"Generic"}/>
						</FormGroup>
					</div>
					{!this.state.isGeneric &&
						<>
							<div className={'col-5'}>
								<Framework.Elements.Select
									shouldLoad={loaded}
									property={properties.region}
									value={region}
									error={region_error}
									object={regions}
									update={this.handleRegionSelect}
									nullable={true}
								/>
							</div>
							<div className={'col-5'}>
								<Select
									key={this.state.sub_regions}
									placeholder={"Sub-Region Select"}
									isMulti={false}
									isClearable
									value={this.state.selectedSubRegion}
									onChange={(value) => {
										this.setState({selectedSubRegion: value, sub_region: value.value})
									}}
									options={this.state.sub_regions.map(region => {
										return (
											{value: region.pkey, label: region.name})
									})}
									styles={this.styles}
								/>
							</div>
						</>
					}
					<div className={'col-6'}>
						<Select
							key={this.state.userRoles}
							placeholder={"Accesses"}
							isMulti={true}
							isClearable={false}
							value={this.state.selectedUserRoles.map(role => {
								return (
									{value: role.value, label: role.label}
								)
							})}
							onChange={this.handleRoles}
							options={this.state.userRoles?.map((role) => {
								return {value: role.value, label: role.name}
							})}
							styles={this.styles}
						/>
					</div>
				</div>}
				<Card>
					<CardHeader title={<Framework.Elements.TextField
						property={properties.title}
						value={object.title}
						error={object.title_error}
						update={this.handleTextFieldPropertyUpdate}
					/>}/>
					<CardContent style={{position: "relative"}}>
						<Framework.Elements.TextField
							property={properties.information}
							value={object.information}
							error={object.information_error}
							update={this.handleTextFieldPropertyUpdate}
							multiline={4}
						/>
					</CardContent>
					{!this.props.isNew &&
						<CardActions disableSpacing={true} style={{display: 'flex', justifyContent: 'space-between'}}>
							{!this.props.isNew && this.props.editable && <div style={{marginRight: 'auto', width: '16rem'}}>
								<Select
									key={this.state.userRoles}
									placeholder={"Accesses"}
									isMulti={true}
									isClearable={false}
									value={this.state.selectedUserRoles.map(role => {
										return (
											{value: role.value, label: role.label}
										)
									})}
									onChange={this.handleRoles}
									options={this.state.userRoles?.map((role) => {
										return {value: role.value, label: role.name}
									})}
									styles={this.styles}
								/>
							</div>}
							{this.props.editable && <Button color="danger" onClick={this.handleDelete}>Delete</Button>}
							{this.props.editable && <Button color="primary" onClick={this.handleSubmit}>Save</Button>}
							<Button color="success" onClick={this.handleCopy}>Copy</Button>

						</CardActions>
					}
				</Card>
			</fieldset>
		)
	}

	customStyles = {
		control: (provided) => ({
			...provided,
			minHeight: 32
		}),
		valueContainer: (provided) => ({
			...provided,
			padding: '1px 6px'
		}),
		dropdownIndicator: (provided) => ({
			...provided,
			padding: 4,
		}),
		menu: (provided) => ({
			...provided,
			zIndex: 3,
		})
	};

	styles = {
		...this.customStyles, ...{
			container: (provided) => ({
				...provided,
			}),
			control: (provided) => ({
				...provided,
				minHeight: '30px'
			}),
			valueContainer: (provided) => ({
				...provided,
				overflow: 'visible',
				padding: '1px 8px'
			}),
			placeholder: (provided, state) => ({
				...provided,
				position: "absolute", //(state.hasValue && state.selectProps.value.label) &&
				top: -4,
				left: -4,
				marginLeft: 0,
				marginRight: 0,
				fontSize: '1rem',
				color: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'rgba(0, 0, 0, 0.54)',
				transition: "top 200ms, margin-left 200ms, background-color 200ms, font-size 200ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
				transform: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) ? "translate(14px, -6px) scale(0.75) !important" : "translate(14px, 10px) scale(1) !important",
				transformOrigin: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && "top left",
				//transform: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'matrix(0.75, 0, 0, 0.75, 14, -6)',
				backgroundColor: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'white',
				padding: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && '0 8px',
			}),
			multiValue: (provided) => ({
				...provided,
				zIndex: 2
			})
		}
	};
}

export default Framework.Components.withRootState(Copyable);
